<template>
  <b-modal
    :visible="visible"
    size="lg"
    hide-header
    hide-footer
    centered
    body-class="p-0"
    @change="$emit('update:visible', $event)"
  >
    <div class="po-detail" v-if="slip">
      <div class="po-detail-head">
        <div class="po-detail-head-left">
          <span class="po-detail-code">{{ slip.code }}</span>
          <span class="po-type-badge" :class="slip.isImport ? 'po-type-badge--import' : 'po-type-badge--export'">
            <i :class="slip.isImport ? 'fas fa-arrow-down' : 'fas fa-arrow-up'"></i>
            {{ slip.typeName }}
          </span>
          <div class="po-detail-sub">
            Tạo lúc {{ formatDateTime(slip.createdAt) }} · {{ slip.createBy || '—' }}
          </div>
        </div>
        <button type="button" class="po-detail-close" @click="close">
          <i class="mdi mdi-close"></i>
        </button>
      </div>

      <div class="po-detail-body">
        <div class="po-detail-cards">
          <div class="po-detail-card">
            <div class="po-detail-card-label"><i class="mdi mdi-warehouse"></i> KHO</div>
            <div class="po-detail-card-value">{{ slip.sourceWarehouseId || '—' }}</div>
          </div>
          <div class="po-detail-card">
            <div class="po-detail-card-label"><i class="mdi mdi-calendar"></i> NGÀY</div>
            <div class="po-detail-card-value">{{ formatDate(slip.createdAt) }}</div>
          </div>
          <div class="po-detail-card">
            <div class="po-detail-card-label"><i class="mdi mdi-account"></i> NGƯỜI TẠO</div>
            <div class="po-detail-card-value">{{ slip.createBy || '—' }}</div>
          </div>
          <div class="po-detail-card">
            <div class="po-detail-card-label"><i class="mdi mdi-cellphone"></i> TỔNG SL</div>
            <div class="po-detail-card-value">{{ totalQuantity }}</div>
          </div>
        </div>

        <div v-if="slip.description" class="po-detail-note">
          <div class="po-detail-note-label">GHI CHÚ</div>
          <div class="po-detail-note-text">{{ slip.description }}</div>
        </div>

        <div class="po-detail-products">
          <div class="po-detail-products-head">
            <span class="po-detail-products-title">Chi tiết sản phẩm</span>
            <span class="po-detail-products-count">{{ details.length }} dòng</span>
          </div>

          <div v-if="loading" class="text-center text-muted py-4">
            <b-spinner small /> Đang tải...
          </div>

          <table v-else class="po-detail-table">
            <thead>
              <tr>
                <th>SẢN PHẨM</th>
                <th>IMEI</th>
                <th class="text-center">SL</th>
                <th class="text-right">GIÁ</th>
                <th class="text-right">THÀNH TIỀN</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in details" :key="index">
                <td>
                  <div class="po-detail-product">
                    <ProductImage v-if="item.productImageUrl" :src="item.productImageUrl" class="po-detail-img" />
                    <div v-else class="po-detail-img-placeholder"><i class="mdi mdi-image-off-outline"></i></div>
                    <div>
                      <div class="po-detail-product-code">({{ item.productCode }})</div>
                      <div class="po-detail-product-name">{{ item.productName }}</div>
                    </div>
                  </div>
                </td>
                <td>
                  <span class="po-detail-imei">{{ item.productImei }}</span>
                </td>
                <td class="text-center">{{ item.quantity }}</td>
                <td class="text-right">{{ convertPrice(item.unitPrice) }}</td>
                <td class="text-right font-weight-bold">{{ convertPrice(item.totalAmount) }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4" class="text-right po-detail-total-label">Tổng cộng</td>
                <td class="text-right po-detail-total-value">{{ convertPrice(grandTotal) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div class="po-detail-foot">
        <b-button variant="light" size="sm" @click="close">Đóng</b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import moment from 'moment';
import ApiService from '@/core/services/api.service';
import { convertPrice } from '@/utils/common';
import ProductImage from '@/view/components/products/ProductImage.vue';

export default {
  name: 'ProductionOrderDetailModal',
  components: { ProductImage },
  props: {
    visible: { type: Boolean, default: false },
    slip: { type: Object, default: null },
  },
  data() {
    return {
      loading: false,
      details: [],
    };
  },
  computed: {
    grandTotal() {
      return this.details.reduce((sum, item) => sum + (Number(item.totalAmount) || 0), 0);
    },
    totalQuantity() {
      return this.details.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
    },
  },
  watch: {
    visible(value) {
      if (value && this.slip) {
        this.fetchDetail();
      }
    },
  },
  methods: {
    convertPrice,
    formatDate(value) {
      return value ? moment(value).format('DD/MM/YYYY') : '—';
    },
    formatDateTime(value) {
      return value ? moment(value).format('HH:mm DD/MM/YYYY') : '—';
    },
    close() {
      this.$emit('update:visible', false);
    },
    async fetchDetail() {
      this.loading = true;
      this.details = [];
      try {
        const { data } = await ApiService.get(`v1/stock-slips/${this.slip.id}`);
        this.details = data.data.details || [];
      } catch (error) {
        const message = error?.response?.data?.message || 'Không tải được chi tiết phiếu';
        this.$bvToast.toast(message, { title: 'Thông báo', variant: 'danger', solid: true });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
